<template>
  <FieldBase
    :input-type="inputType"
    :name="name"
    :label="label"
    :size="size"
    :loading="loading"
    :helper-message="helperMessage"
    :has-error="hasError"
    :error-message="errorMessage"
    :is-error-checked="isErrorChecked"
    :show-password-control="showPasswordControl"
  >
    <template slot="field" slot-scope="{ fieldType }">
      <the-mask
        v-if="mask"
        :id="name"
        ref="input"
        :name="name"
        :mask="mask"
        :autofocus="autofocus"
        :required="required"
        :type="fieldType"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        class="c-field"
        @input="inputMasked"
        @blur.native="blur"
        @focus="$emit('focus', $event)"
      />
      <input
        v-else
        :id="name"
        ref="input"
        :name="name"
        :autofocus="autofocus"
        :required="required"
        :mask="mask"
        :type="fieldType"
        :value="value"
        :readonly="readonly"
        :placeholder="placeholder"
        :disabled="disabled"
        :autocomplete="autocomplete"
        class="c-field"
        @input="input"
        @blur="blur"
        @focus="$emit('focus', $event)"
        @keypress.enter="$emit('enter', $event)"
      />
    </template>
  </FieldBase>
</template>

<script>
import fieldBaseMixin from '../FieldBase/mixin'
export default {
  name: 'Field',
  mixins: [fieldBaseMixin],
  props: {
    inputType: {
      type: String,
      default: 'text',
    },
    mask: {
      type: [String, Array],
      default: '',
    },
    showPasswordControl: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
